import React, { PureComponent } from 'react';
import { strings } from 'APP_ROOT/localization';

export default class BackToTopButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showButton: false,
    };
    
    this.buttonRef = React.createRef();

    this.handleScroll = this.throttle(this.handleScroll.bind(this), 100);
  }
  
  throttle(func, delay) {
    let lastExecutionTime = 0;

    return function (...args) {
      const now = new Date().getTime();

      if (now - lastExecutionTime >= delay) {
        lastExecutionTime = now;
        func(...args);
      }
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if(this.buttonRef.current) {
      const buttonRef = this.buttonRef.current;
      if (window.scrollY > 300) {
        buttonRef.classList.add('show');
      } else {
        buttonRef.classList.remove('show');
      }
    }
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  render() {
    return (
        <div ref={this.buttonRef} className='back-to-top'>
            <button
                className='btn-icon btn-outline-transparent'
                onClick={this.scrollToTop}
            >
                <i className="material-icons">keyboard_double_arrow_up</i>
            </button>
            <span>{strings.back_to_top}</span>
        </div>
    );
  }
}